<div class="kantoor-error">
    <div class="kantoor-error__container">
        <div class="kantoor-error__illustration">
            <ap-illustration name="error" width="185" height="185"></ap-illustration>
        </div>
        <h2 class="tertiary">
            <p>{{ title }}</p>
        </h2>
        <span class="kantoor-error__message">
            <p>{{ message }}</p>
        </span>
        <a class="kantoor-error__link" [routerLink]="link">
            <p>{{ linkText }}</p>
        </a>
    </div>
</div>
